import {Load} from "./Load";
import {Modal} from "./Modal";
import {Video} from "./Video";
import {Metrics} from "./Metrics";

export class Basic
{
    static init()
    {
        Basic.base = '/';
        Basic.lang = document.documentElement.lang;
        Basic.resizeTimer = 0;
        Basic.scrollTimer = 0;
        Basic.ise = (document.body.dataset.ise === 'on');
        Basic.sliders = {};
        Basic.navHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-height'));
        Basic.v = {
        }
    }

    static add_changeEvent()
    {
        document.body.addEventListener('change',async e =>
        {
            let el = e.target;

            if(el.closest('.w__js-change'))
            {
                el = el.closest('.w__js-change');
            }

            if(el.classList.contains('w__js-change') &&
              !el.classList.contains('inactive') &&
               el.dataset.f)
            {
                switch(el.dataset.f)
                {
                    default:
                        console.log('Missing case change: ' + el.dataset.f);
                }
            }
        });
    }

    static add_clickEvent()
    {
        document.body.addEventListener('click',async e =>
        {
            let el = e.target;

            if(el.classList.contains('ise') || el.closest('.ise'))
            {
                return false;
            }
            else if(el.closest('.w__js-button'))
            {
                el = el.closest('.w__js-button');
            }

            if(el.classList.contains('w__js-button') &&
                el.dataset.f)
            {
                switch(el.dataset.f)
                {
                    case 'newsletter':
                        e.preventDefault();
                        await Basic.build_newsletterModal(el);
                        break;

                    case 'toggle-details':
                        el.classList.toggle('mod--open');
                        el.textContent = el.classList.contains('mod--open') ? 'Hide details' : 'Show details';
                        break;

                    case 'toggle-menu':
                        document.body.classList.toggle('mod--menu-open');
                        break;

                    case 'video':
                        e.preventDefault();
                        new Video(el);
                        break;

                    default:
                        console.log('Missing case: ' + el.dataset.f);
                }
            }
            else if(el.classList.contains('file') && el.dataset.fileId)
            {
                Metrics.log_file(el.dataset.fileId);
            }
        });
    }

    static async build_newsletterModal(el)
    {
        try
        {
            const r = await Load.fetch({
                f: 'newsletter-popup'
            });
            const myModal = new Modal(r['html'],true);
            const firstInput = document.getElementById('EMAIL');
            const myForm = document.getElementById('w--modal-form');

            if(firstInput)
            {
                firstInput.focus();
            }

            if(myForm)
            {
                myForm.action = el.dataset.url;
            }
            else
            {
                myModal.remove()
            }
        }
        catch(error)
        {
            new Modal('The newletter form failed to load.',true);
        }
    }

    static process_resize()
    {
    }

    static process_scroll()
    {
    }

    static scroll_toTop()
    {
        document.documentElement.scrollTo(0,0);
    }
}

